import { getIdOrNull, isNonEmptyArray, isObject, validateString, formatAsArray } from '..'
import { ValidationFields } from '../validators'

export const SCHEDULES = {
  DAY: 'DAY',
  NIGHT: 'NIGHT'
}
export const TYPES = {
  SECTOR: 'SECTOR',
  TRAIL: 'TRAIL'
}

export const SECTOR_VALIDATORS = [
  { key: ValidationFields.COMMENT, validator: s => validateString(s.comment, { nullable: true }) },
  { key: ValidationFields.EMPLACEMENT, validator: s => validateString(s.emplacement, { nullable: true }) },
  { key: ValidationFields.NAME, validator: s => validateString(s.name, { notEmpty: true }) },
  { key: ValidationFields.INSTITUTION, validator: s => s.institution !== null },
  { key: ValidationFields.SCHEDULES, validator: s => Array.isArray(s.schedules) && (s.schedules.lenght === 0 || s.schedules.every(schedule => Object.values(SCHEDULES).includes(schedule))) },
  { key: ValidationFields.TYPE, validator: s => s.type === null || Object.values(TYPES).includes(s.type) }
]

export const getName = s => {
  return s.name ?? null
}

export const getComment = s => {
  return s.comment ?? null
}

export const getEmplacement = s => {
  return s.emplacement ?? null
}

export const getInstitutionName = s => {
  return s.institution?.name ?? null
}

export const getHospitalDepartmentName = s => {
  return s.hospitalDepartment?.name ?? null
}

export const isOpenToSection = (sector, { section = null, sectionToYear = null } = {}) => {
  const sectionToYearId = getIdOrNull(sectionToYear)
  const sectionId = getIdOrNull(section)

  if (!isNonEmptyArray(sector?.acceptedSectionToYears)) {
    return true
  }

  if (sectionToYearId !== null) {
    return sector.acceptedSectionToYears.includes(sectionToYearId)
  }

  return sectionId === null || (sector.acceptedSections ?? []).includes(sectionId)
}

export const isSectionAccepted = (sectors, selection) => {
  const activeSectors = sectors.filter(sector => !sector.archived)

  return activeSectors.length === 0 || activeSectors.some(sector => isOpenToSection(sector, selection))
}

export class Sector {
  constructor ({
    id, actTypes = [], archived = false, comment = '', composition = null, emplacement = '', institution, managers = [], name = '', pausesEnabled = false,
    phoneNumber = '', schedules = [], studentPathways = [], tutors = [], type = null
  } = {}) {
    this.id = id ?? -1
    this.actTypes = actTypes
    this.archived = archived
    this.comment = comment
    this.composition = composition
    this.emplacement = emplacement
    this.institution = isObject(institution) ? institution : null
    this.managers = formatAsArray(managers)
    this.name = name
    this.pausesEnabled = pausesEnabled
    this.phoneNumber = phoneNumber
    this.schedules = schedules
    this.studentPathways = studentPathways
    this.tutors = formatAsArray(tutors)
    this.type = type
  }

  toRequestBody = () => {
    const body = { ...this }

    body.institution = this.institution?.id ?? null
    body.managers = this.managers.map(m => m.id)
    body.tutors = this.tutors.map(t => t.id)
    body.studentPathways = this.studentPathways.map(sp => ({ id: sp.id, details: sp.details, sectionToYear: sp.sectionToYear.id }))

    return body
  }
}
